import UserMenuContent from './UserMenuContent';

const UserMenu = ({ isAuthenticated, sandboxSignInUrl, lab, onOpenLabAccess }) => {
  return (
    <div className="user-menu-container" id="user-menu">
      <UserMenuContent
        isAuthenticated={isAuthenticated}
        sandboxSignInUrl={sandboxSignInUrl}
        lab={lab}
        onOpenLabAccess={onOpenLabAccess}
      />
    </div>
  );
};

export default UserMenu;
